
interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface ingredients {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    // ingredients: ingredients;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const sportsinjury: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} =
{
    "en": {
        "url": "sports-injuries",
        "meta": {
            "title": "Sports Injuries Treatment Dubai | Elite Body Home",
            "description": "Expert treatment for sports injuries including fractures, sprains, strains and ligament tears. Personalized rehabilitation plans for athletes and active individuals.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/sports-injuries/",
            "og": {
                "title": "Sports Injuries Treatment Dubai | Elite Body Home",
                "description": "Comprehensive care for sports-related injuries with advanced rehabilitation",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-53.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Sports Injuries"],
        "hero": {
            "title": "Sports Injuries Treatment Dubai",
            "subtitle": "Regain Your Strength & Keep Playing Longer",
            "description": "Injuries like these are called sports injuries — damage done to muscle, ligaments or bone caused by physical activity such as running, jumping or lifting. These injuries can range from mild sprains and strains to more serious fractures or dislocations. Early identification and intervention are critical for the best recovery and to reduce the risk of lasting effects. Elite Body Home Polyclinic also offers tailored treatments for different sports injuries to keep you fit for your pastime."
        },
        "howItWorks": {
            "title": "Expert Physiotherapists treat common sports injuries",
            "description": "An understanding of the types of common sport injuries is crucial for detecting and addressing early. Different kinds of injury have different types of care and recovery."
        },
        "procedureSteps": {
            "heading": "Treatment Process for Sports Injuries with Sports Injury Specialists",
            "para": "Sports Injuries Companies in Dubai — Elite Body Home Polyclinic Here's what you need to know about treatment:",
            "steps": [
                {
                    "title": "Initial Assessment",
                    "desc": "Our practitioners initially perform a thorough assessment to determine the extent of your injury. Tests like X-rays, MRIs or ultrasounds may offer a diagnosis.",
                    "icon": "fa-solid fa-clipboard-check"
                },
                {
                    "title": "Personalized Treatment Plan",
                    "desc": "From that assessment, we will tailor a personalized treatment plan. This could include: Rest and Immobilization, Physical Therapy, Medications, Operative Treatment, and Rehabilitation.",
                    "icon": "fa-solid fa-file-medical"
                },
                {
                    "title": "Rehabilitation",
                    "desc": "After care rehab assists normalization of mobility and a safe return to sports.",
                    "icon": "fa-solid fa-dumbbell"
                },
                {
                    "title": "Follow-Up Care",
                    "desc": "Monitoring the injury regularly helps ensure it heals correctly, and allows modifications to the treatment plan to be made where appropriate.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits",
            "subheading": "",
            "para": "Some of the benefits of treating sports injuries quickly and effectively include: Ongoing, intensive intervention not only hastens recovery, but reduces the risk of complications and recurrence.",
            "items": [
                {
                    "title": "Prevents Chronic Conditions",
                    "desc": "Early attention can prevent chronic problems — joint instability, chronic pain and the like.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "Faster Recovery",
                    "desc": "With appropriate treatment, you will be back to practicing your sport or activity in the least amount of time.",
                    "icon": "fa-solid fa-stopwatch"
                },
                {
                    "title": "Improves Performance",
                    "desc": "Rehabilitation builds strength in the injured area which may lead to better performance after recovery.",
                    "icon": "fa-solid fa-chart-line"
                },
                {
                    "title": "Reduces Pain and Swelling",
                    "desc": "Quick attention helps reduce discomfort and inflammation — so recovery is smoother.",
                    "icon": "fa-solid fa-heartbeat"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "",
            "para": "Sports injuries that should be treated professionally Most people get hurt during sports that require doctor's attention. Here's when you should get treatment:",
            "items": [
                {
                    "title": "Severe Pain",
                    "desc": "If you have severe pain, especially in joints or bones, you should be evaluated immediately.",
                    "icon": "fa-solid fa-exclamation-triangle"
                },
                {
                    "title": "Swelling and Bruising",
                    "desc": "Signs of internal damage that require attention are significant swelling or bruising following an injury.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "Restricted Movement",
                    "desc": "Inability to move or bear weight is a signal that you need medical intervention.",
                    "icon": "fa-solid fa-wheelchair"
                },
                {
                    "title": "Recurring Injuries",
                    "desc": "If you keep hurting the same part of your body, your treatment can help you identify the root cause and treat it.",
                    "icon": "fa-solid fa-redo"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "",
            "para": "What to do before a sports injury treatment.",
            "items": [
                {
                    "title": "Rest the Injured Area",
                    "desc": "Do not use the injured body part before your appointment, as this may inflict more damage.",
                    "icon": "fa-solid fa-bed"
                },
                {
                    "title": "Ice the Injury",
                    "desc": "Use ice to help with swelling and pain until you can see a doctor.",
                    "icon": "fa-solid fa-snowflake"
                },
                {
                    "title": "Keep a Record",
                    "desc": "Note the time of the injury, symptoms and movements that trigger pain. This will help the health care provider determine your needs.",
                    "icon": "fa-solid fa-book-medical"
                },
                {
                    "title": "Wear Comfortable Clothing",
                    "desc": "Wear or choose clothing that can be easily removed or adjusted for general inspection of the injury.",
                    "icon": "fa-solid fa-tshirt"
                }
            ]
        },
        "results": {
            "heading": "Results & Recovery",
            "subheading": "",
            "para": "Any sports injury treatment should aim to correct the problem so that you return to full health and performing again. At Elite Body Home Polyclinic, We treat you in the way of:",
            "items": [
                {
                    "title": "Full Mobility",
                    "desc": "Is the point at which they both have full movement and strength of the affected area.",
                    "icon": "fa-solid fa-running"
                },
                {
                    "title": "Pain-Free Activity",
                    "desc": "So, that ensures returning to sports, pain free, or the lack of discomfort.",
                    "icon": "fa-solid fa-smile"
                },
                {
                    "title": "Preventing Re-Injury",
                    "desc": "Building muscle and increasing flexibility to minimize the risk of re-injury.",
                    "icon": "fa-solid fa-user-shield"
                }
            ]
        },
        "aftercareTips": {
            "heading": "What Does Elite Body Home do to Treat Sports Injuries?",
            "subheading": "",
            "para": "For expert sports injury care contact Elite Body Home comprising some of the most highly trained professionals in the industry, from sports physicians to physiotherapists. Our individual treatment plans, advanced modalities, and complete rehabilitation will get you back to sports sooner and possibly even faster than before!",
            "items": []
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "Common questions about sports injury treatment and recovery",
            "items": [
                {
                    "question": "What should I do immediately after a sports injury?",
                    "answer": "Apply the RICE method: Rest, Ice, Compression, and Elevation. This helps reduce swelling and pain while minimizing further injury. Seek medical advice for proper assessment."
                },
                {
                    "question": "How do I know if I need to see a doctor for my injury?",
                    "answer": "See a doctor if you experience severe pain, swelling, inability to move the affected area, or if symptoms worsen over time."
                },
                {
                    "question": "What types of sports injuries do you treat?",
                    "answer": "We treat sprains, strains, fractures, tendonitis, dislocations, ligament tears, and muscle injuries."
                },
                {
                    "question": "Do I need imaging tests like X-rays or MRIs?",
                    "answer": "Imaging tests may be required to diagnose fractures, ligament tears, or severe joint issues."
                },
                {
                    "question": "What treatment options are available for sports injuries?",
                    "answer": "Treatments include physical therapy, manual therapy, electrotherapy, pain management, and in severe cases, surgery or PRP injections."
                },
                {
                    "question": "How long does it take to recover from a sports injury?",
                    "answer": "Recovery varies from days/weeks for minor injuries to months for serious ones. A rehabilitation plan helps speed recovery."
                },
                {
                    "question": "Do you offer rehabilitation services after surgery for sports injuries?",
                    "answer": "Yes, we provide post-surgical rehabilitation to restore function, improve mobility, and regain strength safely."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Sport-Injuries-treatment-in-dubai-1-scaled.jpg",
            "beforeAfter": []
        },
        "product": {
            "id": 12,
            "title": "Sports Injuries Treatment in Dubai",
            "description": "Comprehensive care for sports-related injuries with advanced rehabilitation",
            "price": 800
        }
    },
    "ar": {
        "url": "sports-injuries",
        "meta": {
            "title": "علاج الإصابات الرياضية في دبي | ايليت بودي هوم",
            "description": "علاج متخصص للإصابات الرياضية بما في ذلك الكسور والالتواءات والشد العضلي وتمزق الأربطة. خطط تأهيل شخصية للرياضيين والأشخاص النشطين.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/sports-injuries",
            "og": {
                "title": "علاج الإصابات الرياضية في دبي | ايليت بودي هوم",
                "description": "رعاية شاملة للإصابات الرياضية مع برامج تأهيل متقدمة",
                "image": "https://www.elitebodyhome.com/images/sports-injuries-og.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "الإصابات الرياضية"],
        "hero": {
            "title": "علاج الإصابات الرياضية في دبي",
            "subtitle": "استعد قوتك وواصل اللعب لفترة أطول",
            "description": "تُعرف هذه الإصابات باسم الإصابات الرياضية، وهي تلف يصيب العضلات أو الأربطة أو العظام نتيجة لممارسة أنشطة بدنية مثل الجري، أو القفز، أو رفع الأثقال. وقد تتراوح هذه الإصابات بين التواءات وإجهادات خفيفة إلى كسور أو خلع أكثر خطورة، ويتخصص بهذه الإصابات فرع الطب الرياضي. يُعد الكشف المبكر والتدخل العلاجي السريع ضروريان لتحقيق أفضل نتائج للتعافي وتقليل خطر المضاعفات طويلة الأمد. تقدم عيادات ايليت بودي هوم خطط علاج مخصصة لأنواع مختلفة من إصابات الملاعب، لمساعدتك في الحفاظ على لياقتك."
        },
        "howItWorks": {
            "title": "معالجة إصابات الرياضيين من قبل أخصائيي العلاج الطبيعي",
            "description": "يُعد فهم الأنواع الشائعة من الإصابات الرياضية أمر أساسي لاكتشافها مبكرًا والتعامل معها بالشكل الصحيح، فلكل نوع من الإصابات أسلوب رعاية وتعافي مختلف. يتطلب كل نوع من الإصابات الرياضية أساليب رعاية وتعافي مختلفة، بحسب طبيعة الإصابة وشدتها."
        },
        "procedureSteps": {
            "heading": "خطوات علاج إصابات الرياضيين مع أخصائيي إصابات الرياضة",
            "para": "عيادات ايليت بودي هوم هي أفضل عيادات لعلاج الإصابات الرياضية في دبي. إليك ما يجب معرفته عن مراحل العلاج:",
            "steps": [
                {
                    "title": "التقييم الأولي",
                    "desc": "يبدأ الأخصائيون لدينا بتقييم شامل لتحديد شدة الإصابة، وقد تُطلب فحوصات مثل الأشعة السينية أو التصوير بالرنين المغناطيسي أو الموجات فوق الصوتية للتشخيص الدقيق.",
                    "icon": "fa-solid fa-clipboard-check"
                },
                {
                    "title": "خطة علاجية مخصصة",
                    "desc": "تُصمم خطط علاجية فردية بناءً على التقييم. وقد تشمل: الراحة والتثبيت، العلاج الطبيعي، الأدوية، التدخل الجراحي، وإعادة التأهيل.",
                    "icon": "fa-solid fa-file-medical"
                },
                {
                    "title": "إعادة التأهيل",
                    "desc": "يساعد برنامج التأهيل بعد العلاج في استعادة الحركة الطبيعية والعودة الآمنة لممارسة الرياضة.",
                    "icon": "fa-solid fa-dumbbell"
                },
                {
                    "title": "المتابعة الدورية",
                    "desc": "تضمن المتابعة المستمرة للإصابة تعافيها بالشكل الصحيح، كما تسمح بتعديل خطة العلاج عند الحاجة.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "benefits": {
            "heading": "الفوائد",
            "subheading": "",
            "para": "يُسهم التدخل المبكر والمكثف في تسريع التعافي وتقليل خطر حدوث المضاعفات أو تكرار الإصابة. إليك بعض فوائد علاج الإصابات الرياضية بشكل سريع وفعال:",
            "items": [
                {
                    "title": "الوقاية من الحالات المزمنة",
                    "desc": "يمنع الاهتمام المبكر تطور المشكلات المزمنة مثل عدم استقرار المفاصل أو الألم المستمر.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "تعافٍ أسرع",
                    "desc": "يمكنك العودة إلى ممارسة الرياضة أو النشاط البدني في أقصر وقت ممكن عند اتباع العلاج المناسب.",
                    "icon": "fa-solid fa-stopwatch"
                },
                {
                    "title": "تحسين الأداء",
                    "desc": "يساهم برنامج التأهيل في تقوية المنطقة المصابة، مما قد يؤدي إلى أداء رياضي أفضل بعد التعافي.",
                    "icon": "fa-solid fa-chart-line"
                },
                {
                    "title": "تقليل الألم والتورم",
                    "desc": "يساعد التدخل السريع على تخفيف الألم والالتهاب، مما يجعل رحلة التعافي أكثر سلاسة.",
                    "icon": "fa-solid fa-heartbeat"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية",
            "subheading": "",
            "para": "قد تستدعي الإصابات الرياضية التي تحدث أثناء ممارسة أنشطة بدنية علاجًا احترافيًا في أغلب الأحيان، ويجب عدم تجاهلها إذا ظهرت الأعراض التالية:",
            "items": [
                {
                    "title": "ألم شديد",
                    "desc": "يجب التوجه فورًا إلى الطبيب لتقييم الحالة، في حال الشعور بألم حاد، خاصةً في المفاصل أو العظام.",
                    "icon": "fa-solid fa-exclamation-triangle"
                },
                {
                    "title": "تورم وكدمات",
                    "desc": "تشمل علامات التلف الداخلي التي تستدعي التدخل الطبي التورم أو الكدمات الشديدة بعد التعرض لإصابة.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "صعوبة في الحركة",
                    "desc": "يُعد عدم القدرة على الحركة أو تحمل الوزن علامة تستوجب التدخل الطبي.",
                    "icon": "fa-solid fa-wheelchair"
                },
                {
                    "title": "إصابات متكررة",
                    "desc": "يمكن أن يساعد العلاج في تحديد السبب الجذري ومعالجته، في حال تكرار الإصابة في نفس المنطقة.",
                    "icon": "fa-solid fa-redo"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "",
            "para": "ما يجب فعله قبل التوجه للعلاج:",
            "items": [
                {
                    "title": "إراحة المنطقة المصابة",
                    "desc": "تجنب استخدام الجزء المصاب قبل الموعد الطبي لتفادي تفاقم الضرر.",
                    "icon": "fa-solid fa-bed"
                },
                {
                    "title": "استخدام الثلج على موضع الإصابة",
                    "desc": "استخدم الثلج لتقليل التورم والألم مؤقتًا حتى تتمكن من زيارة الطبيب.",
                    "icon": "fa-solid fa-snowflake"
                },
                {
                    "title": "تدوين التفاصيل",
                    "desc": "دوّن وقت حدوث الإصابة، والأعراض التي تشعر بها، والحركات التي تسبب الألم، حيث تساعد هذه المعلومات الطبيب في تحديد التشخيص المناسب.",
                    "icon": "fa-solid fa-book-medical"
                },
                {
                    "title": "ارتداء ملابس مريحة",
                    "desc": "اختر ملابس يسهل خلعها أو تعديلها لتسهيل فحص المنطقة المصابة.",
                    "icon": "fa-solid fa-tshirt"
                }
            ]
        },
        "results": {
            "heading": "النتائج والتعافي",
            "subheading": "",
            "para": "يهدف العلاج إلى استعادة صحتك الكاملة والعودة إلى النشاط الرياضي بأمان. نوفر لك في ايليت بودي هوم:",
            "items": [
                {
                    "title": "استعادة الحركة الكاملة",
                    "desc": "نساعدك على استعادة الحركة والقوة في الجزء المصاب بالكامل.",
                    "icon": "fa-solid fa-running"
                },
                {
                    "title": "ممارسة الأنشطة دون ألم",
                    "desc": "هدفنا هو عودتك إلى التمارين والرياضة دون الشعور بأي ألم أو انزعاج.",
                    "icon": "fa-solid fa-smile"
                },
                {
                    "title": "الوقاية من تكرار الإصابة",
                    "desc": "نركز على تقوية العضلات وتحسين المرونة لتقليل فرص الإصابة مجددًا.",
                    "icon": "fa-solid fa-user-shield"
                }
            ]
        },
        "aftercareTips": {
            "heading": "كيف يتم علاج الإصابات الرياضية في عيادات ايليت بودي هوم؟",
            "subheading": "",
            "para": "تقدم عيادات ايليت بودي هوم رعاية متخصصة للإصابات الرياضية على يد نخبة من الأطباء وأخصائيي العلاج الطبيعي ذوي الكفاءة العالية. نصمم خطط علاج فردية لكل حالة، باستخدام أحدث التقنيات العلاجية وبرامج إعادة التأهيل الشاملة، لمساعدتك على العودة إلى ممارسة الرياضة سريعًا، وربما بأداء أفضل من قبل!",
            "items": []
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "أسئلة شائعة حول علاج الإصابات الرياضية والتعافي",
            "items": [
                {
                    "question": "ما الذي يجب علي فعله مباشرة بعد الإصابة الرياضية؟",
                    "answer": "طبق طريقة RICE: الراحة، الثلج، الضغط، والرفع. هذا يساعد في تقليل التورم والألم مع تقليل خطر تفاقم الإصابة. استشر طبيبًا للتقييم المناسب."
                },
                {
                    "question": "كيف أعرف إذا كنت بحاجة لرؤية طبيب لإصابتي؟",
                    "answer": "راجع الطبيب إذا كنت تعاني من ألم شديد، تورم، عدم القدرة على تحريك المنطقة المصابة، أو إذا ساءت الأعراض مع الوقت."
                },
                {
                    "question": "ما أنواع الإصابات الرياضية التي تعالجونها؟",
                    "answer": "نعالج الالتواءات، الشد العضلي، الكسور، التهاب الأوتار، الخلع، تمزق الأربطة، وإصابات العضلات."
                },
                {
                    "question": "هل أحتاج إلى فحوصات تصويرية مثل الأشعة السينية أو الرنين المغناطيسي؟",
                    "answer": "قد تكون فحوصات التصوير ضرورية لتشخيص الكسور، تمزق الأربطة، أو مشاكل المفاصل الشديدة."
                },
                {
                    "question": "ما خيارات العلاج المتاحة للإصابات الرياضية؟",
                    "answer": "تشمل العلاجات العلاج الطبيعي، العلاج اليدوي، العلاج الكهربائي، إدارة الألم، وفي الحالات الشديدة، الجراحة أو حقن البلازما الغنية بالصفائح الدموية."
                },
                {
                    "question": "كم من الوقت يستغرق التعافي من الإصابة الرياضية؟",
                    "answer": "يختلف التعافي من أيام/أسابيع للإصابات البسيطة إلى شهور للحالات الشديدة. تساعد خطة التأهيل في تسريع التعافي."
                },
                {
                    "question": "هل تقدمون خدمات تأهيلية بعد جراحة الإصابات الرياضية؟",
                    "answer": "نعم، نقدم خدمات تأهيل ما بعد الجراحة لاستعادة الوظيفة، تحسين الحركة، واستعادة القوة بأمان."
                }
            ]
        }
    }
}